import * as React from 'react';
import { observer } from 'mobx-react-lite';
import {
    AttachmentLocalComputerFilePicker,
    FilePickerAction,
    FileSelectionFilter,
} from 'owa-attachment-filepicker';
import type AttachmentMultiPicker from 'owa-mail-compose-view/lib/types/AttachmentMultiPicker';
import type CreateAttachmentHandlers from 'owa-mail-compose-view/lib/types/CreateAttachmentHandlers';
import { getCreateAttachmentHandlers } from 'owa-mail-compose-view/lib/utils/getCreateAttachmentHandlers';
import { attachmentMultiMenuEntry } from 'owa-attachment-multi-menu-actions';
import type { ComposeViewState } from 'owa-mail-compose-store';
import loadAttachmentSuggestions from 'owa-mail-compose-actions/lib/utils/loadAttachmentSuggestions';
import { getMainWindowComposeViewState } from 'owa-mail-compose-actions/lib/selectors/getMainWindowComposeViewState';

export interface MailAttachmentPickersProps {
    attachmentInlinePickers: AttachmentMultiPicker;
    attachmentMultiPicker: AttachmentMultiPicker;
}

export default observer(function MailAttachmentPickers(props: MailAttachmentPickersProps) {
    const viewState: ComposeViewState | undefined = getMainWindowComposeViewState();
    const { attachmentInlinePickers, attachmentMultiPicker } = props;

    React.useEffect(() => {
        // Pre-load operations
        if (viewState) {
            loadAttachmentSuggestions(viewState);
        }
    }, []);

    const attachmentHandlers: CreateAttachmentHandlers = React.useMemo(
        () =>
            getCreateAttachmentHandlers(attachmentMultiPicker, attachmentMultiMenuEntry, viewState),
        [attachmentMultiPicker, attachmentMultiMenuEntry, viewState]
    );

    return (
        <>
            <AttachmentLocalComputerFilePicker
                ref={attachmentInlinePickers.computer.current}
                fileSelectionFilter={FileSelectionFilter.Images}
                action={FilePickerAction.InsertInlineImage}
                createAttachmentHandler={attachmentHandlers.computer}
            />

            <AttachmentLocalComputerFilePicker
                ref={attachmentMultiPicker.computer.current}
                fileSelectionFilter={FileSelectionFilter.None}
                action={FilePickerAction.Attach}
                createAttachmentHandler={attachmentHandlers.computer}
            />
            <AttachmentLocalComputerFilePicker
                ref={attachmentMultiPicker.onlineLocation.current}
                fileSelectionFilter={FileSelectionFilter.None}
                action={FilePickerAction.Attach}
                createAttachmentHandler={attachmentHandlers.uploadAndLinkFromCloud}
            />
            <AttachmentLocalComputerFilePicker
                ref={attachmentMultiPicker.uploadAndShareFromCloud.current}
                fileSelectionFilter={FileSelectionFilter.None}
                action={FilePickerAction.InsertAsLink}
                createAttachmentHandler={attachmentHandlers.uploadAndShareFromCloud}
            />
        </>
    );
});
